import styled from 'styled-components';

interface IStandardSlideStProps {
  withBackground?: boolean;
  offset?: number;
}

export const StandardSlideSt = styled.div<IStandardSlideStProps>`
  min-width: 100%;
  position: ${({ withBackground }) => withBackground && 'relative'};
  transition: transform 0.3s;
  transform: ${({ offset }) =>
    `translate(calc((${-(offset * 100)}% / 2) + (${-(
      offset * 100
    )}% / 2)), 0) `};
`;

export const StandardSlidesContainerSt = styled.div`
  height: 100%;
`;
